export enum EUserStatus {
    new = 'new',
    active = 'active',
    inactive = 'inactive',
    exited = 'exited',
    notActivated = 'not-yet-activated'
}
